import App from "../../../vendor_core/core/src/App";
import InstanceFactory from "../../../vendor_core/core/src/factories/InstanceFactory";
import { Tween } from "../../../vendor_core/core/src/Tween";
import ConsoleUtil from "../../../vendor_core/core/src/utils/ConsoleUtil";
import GameLoader from "../../../vendor_core/core/src/utils/GameLoader";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import SoundController from "../../../vendor_core/core/src/utils/SoundController";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import ReelGroup from "../../../vendor_core/core/src/views/ReelGroup";
import VendorPreloadState from "../../../vendor_core/src/states/VendorPreloadState";
import BackgroundHelpers from "../view/background/BackgroundHelper";
import GameSoundVars from "../enums/GameSoundVars";
import { Loader } from "pixi.js-legacy";
import Locale from "../../../vendor_core/core/src/utils/Locale";
import PreloadView from "../../../vendor_core/core/src/views/PreloadView";
import GameModel from "../../../vendor_core/core/src/model/GameModel";
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import { OverlayType } from "../../../vendor_core/core/src/server/data/ISpinData";
import PointerEvents from '../../../vendor_core/core/src/const/PointerEvents';
import ClockController from '../../../vendor_core/core/src/controllers/ClockController';
import UIController from '../../../vendor_core/core/src/ui/UIController';
import ControllerManager from '../../../vendor_core/core/src/utils/ControllerManager';
import VendorModel from '../../../vendor_core/src/model/VendorModel';
import Configs from '../../../vendor_core/src/vendorConfigs/Configs';
import SwitchButton from "../../../vendor_core/core/src/views/components/SwitchButton";
import LogoHelper from "../view/logo/LogoHelper";

export default class VOEPreloaderState extends VendorPreloadState {

    protected setupReels() {
      const reelGroup = InstanceFactory.getClass("ReelGroup", true) as ReelGroup;
      ViewManager.getLayer(DefaultLayers.Reels)
        .getCurrentScene()
        .addSubView(reelGroup, "ReelGroup", "reels");
      reelGroup.create(
        ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene(),
        null,
        {
          winLineLayer: "Paylines",
          celеbrationLayer: "PaylineCelebration",
          winSymbolsLayer: "ReelsWin"
        }
      );

      reelGroup.reels.forEach(reel => {
        reel.symbols.forEach(symbol => {
          symbol.playAnimation("idle");
        });
      });

      if (SpinModel.hasOverlay && SpinModel.overlays.length) {

        let reels = Array.from(Array(reelGroup.reels.length).keys());
        let result = SpinModel.getFinalSymsForReels(reels);
        reelGroup.showFinalSymbols(result);

        SpinModel.overlays.forEach((overlay) => {
          if (overlay.type == OverlayType.Expanding) {
            overlay.initPositions.forEach((obj) => {
             // reelGroup.getSymbolAt(obj.reel, obj.row)
             //   .playAnimation("expanded_" + (obj.row+1));
            });
          }
        });
      }
    }

    startGame() {
      UIController.removeTurboListener()
      BackgroundHelpers.backgroundLoop();
      super.startGame();
    }

    protected onClientConfigReceived(data) {
      super.onClientConfigReceived(data);
      // Clean this array for apply min spin time on turbo/fast spin behavior
      App.config.NO_SKIP_JURISDICTION = [];
    }

    public closePreloadScene() {

      const preloadLayer = ViewManager.getLayer(DefaultLayers.Preloader);
      const scene = preloadLayer.setScene("start");
      this.buildViews();

      // https://docs.relax-gaming.com/partners/portal/social-casino
      if (GameModel.lang == "en-sc") {
        (ViewManager.getLayer(DefaultLayers.BetBar).setScene().buttons.get("feature") as SwitchButton).switch(true);
      }

      ControllerManager.addController(
          "clockController",
          new ClockController()
      );

      ViewManager.getLayer(DefaultLayers.Header)
          .setScene().sceneTextFields.get("clock")
          .visible = !Configs.game.clientConfig.hideClock;

      if(VendorModel.allowSkipIntro) {
          this.initSoundLoading();
          preloadLayer.clear();
          UIController.addTurboListener();
          this.startGame();
      } else {
          scene.interactive = true;
          scene.on(PointerEvents.DOWN, () => {
              this.initSoundLoading();
              preloadLayer.clear();
              UIController.addTurboListener();
              this.startGame();
          });
      }
  }

    protected initSoundLoading() {

      SoundController.musicVolume = App.config.maxMusicVolume || 1;

      Tween.delayedCall(
        0,
        () => {
          SoundController.setSpecificMusicVolume(GameSoundVars.IDLE_MUSIC, 0);
          SoundController.playMusic(GameSoundVars.IDLE_MUSIC);

        }
      )
      GameLoader.loadSoundAssets(GameLoader.config.sounds, async () => {
        await SoundController.loadSounds(GameLoader.config.sounds);
        SoundController.playSound(GameSoundVars.GAME_START);
        ConsoleUtil.log("Sound resources loaded");
      });
    }

    protected onLoginReceived(data: any): void {
      super.onLoginReceived(data);
    }

    public preloadComplete() {
      LogoHelper.init();
      super.preloadComplete();
    }
}
